module.exports = __webpack_public_path__ + "static/media/hdr.694fc41f.png";